









import { Component, Prop, Vue, Watch, Mixins } from "vue-property-decorator";
import { State, Getter, Action, Mutation } from "vuex-class";
import anime from "animejs";

@Component({})
export default class ContentContainer extends Vue {
  @State(state => state.app.scrollingByScreens) scrollingByScreens!: boolean;

  @Prop({ default: true })
  rightIndent!: boolean;

  @Prop({ default: true })
  leftIndentOnMobile!: boolean;

  @Prop({ default: 0 })
  height!: number;

  @Prop({ default: 0 })
  fullWidthOnWindowWidth!: number;

  @Prop({ default: false })
  relativeOnMobile!: boolean;

  @Prop({ default: false })
  heightAutoOnMobile!: boolean;

  get containerWidth() {
    let width = this.$browser.width;
    if (width < 360) width = 360;
    if (!this.scrollingByScreens) return (width < 1400)? width:1400;
    if (this.fullWidthOnWindowWidth > 0 && this.fullWidthOnWindowWidth > this.$browser.width) return width;
    if (this.$browser.width > 1200 || this.leftIndentOnMobile) width = width - this.indent;
    if (this.rightIndent) width -= this.indent;
    return width;
  }

  get indent() {
    let indent = 220;
    if (!this.scrollingByScreens) return 0;
    if (this.$browser.width < 1200) indent = 80;
    if (this.$browser.width < 1020) indent = 35;
    return indent;
  }

  get right() {
    if (!this.scrollingByScreens) return 0;
    if (this.fullWidthOnWindowWidth > 0 && this.fullWidthOnWindowWidth > this.$browser.width) return 0;
    return (this.rightIndent) ? this.indent : 0;
  }
}
